import { createContext } from "react";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IPagination } from "../../model/pagination";
import { INotificationQuery } from "../../model/notifications";

export type NotificationsLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: NotificationsLoading[];

  list?: any;
  query: INotificationQuery;

  details?: any;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;

    updateNotification: (id: number, request: any) => void;
    deleteNotification: (id: number) => void;
    setQuery: (query: IPagination) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    updateNotification: DEFAULT_FUNCTION,
    deleteNotification: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const NotificationContext = createContext(externalState);

export default NotificationContext;
